import type * as React from 'react';
import { getFile } from '@Domain/Api';
import accountLogoFetched, {
	type AccountLogoFetchedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoFetched';
import accountLogoFetchFailed, {
	type AccountLogoFetchFailedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoFetchFailed';
import type FetchAccountLogo from '@Application/Branding/AccountLogo/Queries/FetchAccountLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import readBlobAsDataUrl from '@Infra/DataUrl/readBlobAsDataUrl';
import parameters from '../../../parameters';

type Actions = AccountLogoFetchedAction | AccountLogoFetchFailedAction;

export default (query: FetchAccountLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const { blob } = await getFile(`${parameters.api.host}/api/accounts/${query.accountId}/logo`);
			// A 204 yields an empty Blob: no logo at this level.
			const dataUrl = blob.size === 0 ? null : await readBlobAsDataUrl(blob);

			const action = accountLogoFetched({ dataUrl }, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountLogoFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
